/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useRef, useState } from 'react';
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import { MyContext } from '../Context/MyProvider';
import { showToast } from '../showTost';
import axios from 'axios';
import Usericon from '../assets/Icon/user.svg';
import Emailicon from '../assets/Icon/email.svg';
import Callicon from '../assets/Icon/call.svg';
import { LuUsers } from "react-icons/lu";
import { useTranslation } from 'react-i18next';
import secureLocalStorage from "react-secure-storage";

const Signup = () => {

    const { t } = useTranslation();
    const { setIsLoginShow, setIsSignUpShow, ApiBaseUrl, setIsLogin } = useContext(MyContext);

    const [value, setValue] = useState();
    const [signUpData, setSignUpData] = useState({
        name: "",
        email: "",
        referral: ""
    });
    const [isOtpShow, setIsOtpShow] = useState(false);
    const [otpFiled, setOtpFiled] = useState(Array(6).fill(''));
    const [sendOtp, setSendOtp] = useState("");
    const [apiloading, setApiLoading] = useState(false);

    const InputRef = useRef();
    const OtpRef = useRef(Array.from({ length: 6 }, () => null));

    const handelCheck = () => {
        const emailValidation = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (apiloading) {
            return;
        }

        if (!signUpData.name || !signUpData.email || !value) {
            showToast({ title: t("Please Enter Details"), id: "warning" });
            return;
        }

        if (!emailValidation.test(signUpData.email)) {
            showToast({ title: t("Please Enter a Valid Email"), id: "warning" });
            return;
        }

        const formattedNumber = formatPhoneNumberIntl(value);
        if (!formattedNumber) {
            showToast({ title: t("Please enter a valid phone number"), id: "warning" });
            return;
        }
        const countryCode = formattedNumber.split(' ')[0];
        const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
        const cleanedNumber = numberWithoutCode.split(' ').join('');

        setApiLoading(true);

        const Data = {
            phone: cleanedNumber,
            ccode: countryCode,
            email: signUpData?.email
        };

        axios.post(`${ApiBaseUrl}/customer/mobile_check`, Data)
            .then((res) => {
                const { ResponseCode, message, Result, email_result } = res.data;
                if (ResponseCode === 200) {

                    if (!Result) {
                        showToast({ title: message, id: "error" });
                        setApiLoading(false);
                        return;
                    }
                    if (!email_result) {
                        showToast({ title: message, id: "error" });
                        setApiLoading(false);
                        return;
                    }

                    handleMSG91(Data);

                } else {
                    showToast({ title: message, id: "error" });
                    setApiLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setApiLoading(false);
            });
    };

    const handleMSG91 = (data) => {
        axios.post(`${ApiBaseUrl}/customer/msg91`, data)
            .then((res) => {
                setApiLoading(false);
                const { ResponseCode, message, otp } = res.data;
                if (ResponseCode === 200) {
                    showToast({ title: message, id: "success" });
                    setIsOtpShow(true);
                    setSendOtp(otp);
                } else {
                    showToast({ title: message, id: "error" });
                }
            })
            .catch(() => {
                setApiLoading(false);
            });
    };

    const handleChange = (index, val) => {
        const Otp = [...otpFiled];
        Otp[index] = val;
        setOtpFiled(Otp);
        if (val && !isNaN(val) && index < OtpRef.current.length - 1) {
            OtpRef.current[index + 1].focus();
        }
    };

    const InputHandle = (index, e) => {
        if (e.key === "Backspace" && index > 0 && !e.target.value) {
            OtpRef.current[index - 1].focus();
        }
    };

    const HandelVerifyOtp = () => {
        if (sendOtp === otpFiled.join("")) {
            handleSignUp();
        } else {
            showToast({ title: t("OTP is invalid !!"), id: "error" });
        }
    };

    const handleSignUp = () => {

        const formattedNumber = formatPhoneNumberIntl(value);
        const countryCode = formattedNumber.split(' ')[0];
        const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
        const cleanedNumber = numberWithoutCode.split(' ').join('');

        setApiLoading(true);

        const Data = {
            Name: signUpData.name,
            Email: signUpData.email,
            phone: cleanedNumber,
            ccode: countryCode,
            referral_code: signUpData.referral ? signUpData.referral : ""
        };

        axios.post(`${ApiBaseUrl}/customer/signup`, Data)
            .then((res) => {
                const { ResponseCode, customer, message } = res.data;
                if (ResponseCode === 200) {
                    showToast({ title: message, id: "success" });
                    secureLocalStorage.setItem("Loginuser", JSON.stringify(customer));
                    secureLocalStorage.setItem("Userid", customer.id);
                    setIsLogin("123");
                    setIsSignUpShow(false);
                } else {
                    showToast({ title: message, id: "error" });
                }
                setApiLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setApiLoading(false);
            });
    };

    return (
        <div className='signup-box'>
            {isOtpShow
                ? <div className="py-[10px] px-[20px]">
                    <h1 className='text-center text-[24px] font-[500]'>Almost there!</h1>
                    <p className='text-center text-gray-500 text-[16px] leading-[24px] mt-[8px]'>Enter the 6-digit code sent to <span className='text-black font-[500]'>{value}</span></p>
                    <div className="otp-row">
                        {otpFiled.map((val, index) => {
                            return <input type="text"
                                ref={(e) => (OtpRef.current[index] = e)}
                                key={index}
                                value={val}
                                className='otp-box'
                                maxLength="1"
                                inputMode="numeric"
                                autoComplete="one-time-code"
                                onChange={(e) => handleChange(index, e.target.value.replace(/\D/g, '').slice(0, 1))}
                                onKeyDown={(e) => InputHandle(index, e)}
                            />
                        })}
                    </div>
                    <button onClick={HandelVerifyOtp} className='w-[100%] bg-[#0d9488] text-white py-[8px] mt-[20px] font-[500] rounded-[10px]'>
                        {apiloading
                            ? <div className="loader mx-auto"></div>
                            : <span>VERIFY OTP</span>}
                    </button>
                </div>
                : <div className="py-[10px] px-[20px]">
                    <h1 className="text-[24px] font-[500]">Sign Up</h1>
                    <p className="text-gray-500 text-[14px] mt-[6px]">We will send a verification OTP to your mobile number.</p>
                    <div className="login-input focus-within:border-[#0d9488] mt-[20px] focus-within:border-[1px]">
                        <img src={Usericon} alt="userIcon" className="w-[25px]" />
                        <input onChange={(e) => setSignUpData({ ...signUpData, name: e.target.value })} type="text" placeholder='Full Name' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    </div>
                    <div className="login-input focus-within:border-[#0d9488] mt-[20px] focus-within:border-[1px]">
                        <img src={Emailicon} alt="EmailIcon" className="w-[25px]" />
                        <input onChange={(e) => setSignUpData({ ...signUpData, email: e.target.value })} type="email" placeholder='Email' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    </div>
                    <div className="relative gap-[5px] login-input focus-within:border-[#0d9488] mt-[20px] focus-within:border-[1px]">
                        <img src={Callicon} alt="Call Icon" className="w-[25px]" />
                        <PhoneInput
                            className="w-[100%]"
                            ref={InputRef}
                            international
                            defaultCountry="IN"
                            value={value}
                            onChange={setValue}
                            name="phone"
                            style={{ outline: "none" }}
                        />
                        {!value && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[10px] left-[90px] text-gray-500'>Phone Number</h1>}
                    </div>
                    <div className="login-input focus-within:border-[#0d9488] mt-[20px] focus-within:border-[1px]">
                        <LuUsers className='text-[20px] text-[#383e4b]' />
                        <input onChange={(e) => setSignUpData({ ...signUpData, referral: e.target.value })} type="text" placeholder='Referral Code (Optional)' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    </div>
                    <h1 className="mt-[10px] font-[500]">By signing up, you agree to our <span className="text-[#0d9488]">Terms of Service</span> and <span className="text-[#0d9488]">Privacy Policy.</span></h1>
                    <button onClick={handelCheck} className='bg-[#0d9488] w-[100%] py-[8px] text-white font-bold rounded-[10px] mt-[20px]'>
                        {apiloading
                            ? <div className="loader mx-auto"></div>
                            : <span>{t("Send OTP")}</span>}
                    </button>
                    <h1 className='mt-[10px] text-center font-[500]'>Already have an account? <span onClick={() => { setIsLoginShow(true); setIsSignUpShow(false) }} className='text-[#0d9488] cursor-pointer'>Sign In</span> </h1>
                </div>}
        </div>
    )
}

export default Signup
/* jshint ignore:end */
